import { isApiErrorCode } from '@/lib/api-error';

/**
 * แปลง error ที่เกี่ยวกับ attempt เป็น "ต้องพาผู้เรียนไปไหนต่อ"
 *
 * - `finished` = attempt ถูกปิดที่ server แล้ว คำตอบอยู่ครบ ไม่มีอะไรให้ทำต่อ
 *   แยก `alreadySubmitted` ออกจาก `expired` เพราะสองอย่างนี้ต้องขึ้นข้อความคนละแบบ
 *   (ส่งสำเร็จไปแล้ว ≠ หมดเวลา — เคยเหมารวมเป็น "หมดเวลา" ทั้งคู่ ทำให้คนที่กดส่งเองงง)
 * - `reregister` = session token ใช้ไม่ได้ ต้องกรอกอีเมลเดิมเพื่อกลับเข้าไปทำต่อ
 * - `open` = ยังทำต่อได้ (เน็ตหลุด, ยิงถี่เกินไป ฯลฯ) กดใหม่ได้เลย
 */
export type AttemptErrorOutcome =
  | { kind: 'open' }
  | { kind: 'reregister' }
  | { kind: 'finished'; expired: boolean; alreadySubmitted: boolean };

export function attemptErrorOutcome(error: unknown): AttemptErrorOutcome {
  if (isApiErrorCode(error, 'ALREADY_SUBMITTED')) {
    return { kind: 'finished', expired: false, alreadySubmitted: true };
  }
  if (isApiErrorCode(error, 'ATTEMPT_EXPIRED')) {
    return { kind: 'finished', expired: true, alreadySubmitted: false };
  }
  if (isApiErrorCode(error, 'INVALID_SESSION')) return { kind: 'reregister' };
  return { kind: 'open' };
}
